<template>
  <section class="mall-notice-dialog">
    <van-dialog v-model="show" :close-on-click-overlay="true" @close="close">
      <div class="van-dialog__message">
        <p>春节制作延期通知</p>
        <p>
          放假时间：2月10日-2月18日<br>
          订单处理：在放假期间，人工修音服务可正常下单，制作交付及返工的时间将由2天延长至4天<br>
          退款处理：人工关闭或无法制作的订单，退款金额将在1-3天内到账
        </p>
        <p>
          唱吧-人工修音 感谢您的支持与理解，祝新春愉快！
        </p>
      </div>
    </van-dialog>
  </section>
</template>

<script>
export default {
  name: 'MallNoticeDialog',

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      show: false
    }
  },

  watch: {
    value(val) {
      this.show = val;
    }
  },

  created() {
    this.show = this.value;
  },

  methods: {
    close() {
      this.show = false;
      this.$emit('input', this.show);
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss">
@import "~@cdn_css/helper.scss";

.mall-notice-dialog {
  .van-dialog {
    .van-dialog__message {
      color: #121212;
      line-height: 1.5;
      white-space: normal;
      text-align: left;

      p + p {
        margin-top: 10px;
      }
    }
  }
}
</style>
